import { createApp } from 'vue';
import hideSEOurl from '../../../old-static/hideSEOurl';
import Accordion from '../../../storybook/Accordion.vue';
import AccordionItem from '../../../storybook/AccordionItem.vue';

const accordion = document.getElementById('accordion');
if (accordion) {
  createApp({
    components: {
      Accordion,
      AccordionItem
    },
    data() {
      return {
      };
    },
    methods: {
    },
    mounted() {
    }
  }).mount(accordion);
}

document.addEventListener('DOMContentLoaded', () => {
  hideSEOurl();
});